var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7857_32670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40C31.0457 40 40 31.0457 40 20Z",
    fill: "#0F171C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3552 19.024L22.3026 14.3882C23.3833 13.9053 27.0481 12.3601 27.0481 12.3601C27.0481 12.3601 28.7395 11.684 28.5985 13.3258C28.5516 14.0019 28.1757 16.3681 27.7998 18.9274L26.6252 26.5089C26.6252 26.5089 26.5312 27.6196 25.7325 27.8127C24.9338 28.0059 23.6182 27.1367 23.3833 26.9435C23.1953 26.7986 19.8594 24.6256 18.6378 23.5632C18.3089 23.2735 17.9331 22.694 18.6848 22.018C20.3763 20.4244 22.3966 18.4445 23.6182 17.189C24.182 16.6095 24.7458 15.2574 22.3966 16.8993L15.7718 21.4868C15.7718 21.4868 15.02 21.9697 13.6105 21.5351C12.201 21.1005 10.5565 20.521 10.5565 20.521C10.5565 20.521 9.42889 19.7967 11.3552 19.024Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7857_32670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegram-logo.bd6d08911adfc6da2393b1031ccd9954.svg";
export { ForwardRef as ReactComponent };